import { TranscriptionQuotaResult } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { AiAssistantTokensQuotaLevel } from './aiAssistantTokensQuota.types';

const LOW_REMAINING_RATIO = 0.25;
const CRITICAL_REMAINING_RATIO = 0.1;

export const resolveAiAssistantTokensQuotaLevel = (quota: TranscriptionQuotaResult): AiAssistantTokensQuotaLevel => {
   if (quota.limit <= 0 || quota.remainingMinutes <= 0) {
      return 'EXHAUSTED';
   }

   const remainingRatio = quota.remainingMinutes / quota.limit;

   if (remainingRatio <= CRITICAL_REMAINING_RATIO) {
      return 'CRITICAL';
   }

   if (remainingRatio <= LOW_REMAINING_RATIO) {
      return 'LOW';
   }

   return 'SUFFICIENT';
};
